// extracted by mini-css-extract-plugin
export default {"root":"xni95IZ0_XRZuoTyyoqN","courseNumberInput":"jwRDhS6jguWKNTnQaBoS"};